"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable prettier/prettier */
const react_1 = __importDefault(require("react"));
const next12_components_custom_link_1 = __importDefault(require("@gcloud-npm/next12.components.custom-link"));
const next12_components_text_info_n_1 = __importDefault(require("@gcloud-npm/next12.components.text-info-n"));
const menu_group_1 = __importDefault(require("../../menu-group"));
const DefaultMenu = (props) => {
    if (!props.items) {
        return null;
    }
    const items = Object.values(props.items);
    const { location } = props;
    let i = 0;
    return (react_1.default.createElement(react_1.default.Fragment, null, items.map((item) => {
        const link = item.link ? item.link : "#";
        const { text } = item;
        const selectedItem = item.selected;
        if (!item.sections) {
            return (react_1.default.createElement(next12_components_custom_link_1.default, { href: link, title: text, ariaLabel: text, key: `item-${i++}`, target: item.target_link || "_self", taggingInfo: {
                    componentName: "header",
                    componentContent: text,
                    componentVariation: location,
                    componentPerso: "",
                    componentProduct: "",
                }, cyData: `Header item ${text}` },
                react_1.default.createElement("div", { className: `menu-item ${selectedItem ? " selected" : ""} r${props.rehidrate}` },
                    react_1.default.createElement(next12_components_text_info_n_1.default, { text: text, fontType: "font-regular", size: "caption01", color: "grey5", display: "block" }))));
        }
        return react_1.default.createElement(menu_group_1.default, { key: `item-${i++}`, item: item });
    })));
};
exports.default = DefaultMenu;
//# sourceMappingURL=index.js.map